<template>
  <div class="fujiandata-container">
    <div class="overview-card">
      <div class="overview-header">
        <div class="overview-title">数据总览</div>
        <div class="filter-container">
          <el-select v-model="selectedFilter" placeholder="筛选下拉框" @change="handleFilterChange">
            <el-option label="全部" value="all"></el-option>
<!--            <el-option label="客户" value="customer"></el-option>-->
<!--            <el-option label="运营" value="operation"></el-option>-->
<!--            <el-option label="销售" value="sales"></el-option>-->
            <el-option label="福建组" value="fujian"></el-option>
            <el-option label="福建1组" value="fujian1"></el-option>
            <el-option label="福建2组" value="fujian2"></el-option>
          </el-select>
        </div>
      </div>

      <div class="overview-grid" v-if="selectedFilter==='all'">
        <div class="overview-item" v-for="group in filteredChartGroups" :key="group.name">
          <div class="item-title">{{ group.name }}</div>
          <div class="item-main">
            <div class="today-number">{{ formatWan(group.today) }}</div>
            <div class="subline">
              <span class="label">昨日</span>
              <span class="yesterday-number">{{ formatWan(group.yesterday) }}</span>
            </div>
            <div class="trend-row" :class="getTrendClass(group)">
              <span>环比：{{ getWowPercent(group) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 环形图（非全部筛选时显示） -->
    <div class="donut-container" v-if="selectedFilter!=='all'">
      <div class="donut-grid">
        <div class="donut-box">
          <div class="donut-title">今日</div>
          <div ref="todayDonut" class="donut-chart"></div>
        </div>
        <div class="donut-box">
          <div class="donut-title">昨日</div>
          <div ref="yesterdayDonut" class="donut-chart"></div>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-container">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="toConsume" label="今日消费" sortable :sort-method="sortByToConsume">
          <template slot-scope="scope">
            <div class="consume-cell">
              <span>{{ scope.row.toConsume }}</span>
            </div>
            <div class="consume-cell">
              <span
                class="consume-trend"
                :class="getTableTrendClass(scope.row)"
                v-if="shouldShowTrend(scope.row)">
                ({{ getTableTrendText(scope.row) }})
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="yesConsume" label="昨日消费" sortable :sort-method="sortByYesConsume"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from "echarts";

export default {
  name: 'FuJianData',
  data() {
    return {
      selectedFilter: 'all',
      maxBarHeight: 150,

      chartGroups: [],

      users: [
        { uname: '张爱', subAccountName: ['Zhangai01','Zhangai02'] },
        // { uname: '黄加龙', subAccountName: ['Hjialong01','Hjialong02'] },
        { uname: '詹思城', subAccountName: ['zhansic01','zhansic02'] },

        { uname: '周尚安', subAccountName: ['zhoushangan01', 'zhoushangan02'] },
        { uname: '郑伏金', subAccountName: ['zhengfujin01'] },
        { uname: '福建追书浙江端口', subAccountName: ['zjfjzs'] },
        { uname: '张栖宇', subAccountName: ['zhangqiyv1', 'zhangqiyv2'] },
        { uname: '叶福顺', subAccountName: ['yefushun1', 'yefushun2'] },
        { uname: '吴周莉', subAccountName: ['wuzhouli01', 'wuzhouli02'] },
        { uname: '翁媚芳', subAccountName: ['wengmeifang1', 'wengmeifang2'] },
        { uname: '生米', subAccountName: ['shengmi', 'shengmi2'] },
        { uname: '千堆雪', subAccountName: ['qianduxue', 'qianduxue3','qianduxue2'] },
        { uname: '林俊杰', subAccountName: ['linjunjie01', 'linjunjie02'] },
        { uname: '黄祥舟', subAccountName: ['huangxiangzhou', 'huangxz02'] },
        { uname: '福建追书福建端口', subAccountName: ['fjfjzs'] },
        { uname: '陈曦', subAccountName: ['zjchenxi', 'chenxi2'] },
        { uname: '陈慧', subAccountName: ['chenhui1', 'chenhui02'] },
        { uname: '福建代运营', subAccountName: ['zjdaiyunying', 'fjdaiyunying'] },
      ],

      tableData: [],
      originalTableData: [],

      intervalId: null,
      yesDataCache: [],
      toDataCache: [],
      todayChart: null,
      yesterdayChart: null,
      _todayBlankClick: null,
      _yesterdayBlankClick: null,
      _globalClick: null,
    }
  },

  // 创建时获取数据
  created() {
    this.getRedisOverview();
    this.intervalId = setInterval(() => {
      this.getRedisOverview();
      this.selectedFilter = 'all';
    }, 60000); // 1分钟获取一次
  },

  mounted() {
    this._globalClick = (e) => {
      // 检查点击目标是否是 tooltip 内容（防止点击 tooltip 自身时消失）
      let target = e.target
      while (target && target !== document.body) {
        if (target.className && typeof target.className === 'string' && target.className.includes('echarts-tooltip')) {
          return
        }
        target = target.parentNode
      }

      if (this.todayChart && this.$refs.todayDonut && !this.$refs.todayDonut.contains(e.target)) {
        this.todayChart.dispatchAction({ type: 'hideTip' })
        // 强制取消高亮
        this.todayChart.dispatchAction({ type: 'downplay' })
      }
      if (this.yesterdayChart && this.$refs.yesterdayDonut && !this.$refs.yesterdayDonut.contains(e.target)) {
        this.yesterdayChart.dispatchAction({ type: 'hideTip' })
        this.yesterdayChart.dispatchAction({ type: 'downplay' })
      }
    }
    // 使用 mousedown 确保更早触发，避免被阻止冒泡
    document.addEventListener('mousedown', this._globalClick, true)
  },

  // 组件销毁时清除定时器，避免内存泄漏
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this._globalClick) {
      document.removeEventListener('mousedown', this._globalClick, true)
      this._globalClick = null
    }
    if (this.todayChart) {
      this.todayChart.dispose();
      this.todayChart = null;
    }
    if (this.yesterdayChart) {
      this.yesterdayChart.dispose();
      this.yesterdayChart = null;
    }
    if (this._todayBlankClick && this.todayChart) {
      this.todayChart.getZr().off('click', this._todayBlankClick)
      this._todayBlankClick = null
    }
    if (this._yesterdayBlankClick && this.yesterdayChart) {
      this.yesterdayChart.getZr().off('click', this._yesterdayBlankClick)
      this._yesterdayBlankClick = null
    }
  },

  computed: {
    // 动态计算最大值，让柱子按比例缩放
    maxValue() {
      const values = this.chartGroups.flatMap(g => [g.yesterday, g.today])
      return Math.max(...values) || 1
    },
    filteredChartGroups() {
      return this.chartGroups
    }
  },

  watch: {
    selectedFilter(val) {
      if (val !== 'all') {
        this.$nextTick(() => this.renderDonutCharts())
      } else {
        if (this.todayChart) {
          this.todayChart.dispose()
          this.todayChart = null
        }
        if (this.yesterdayChart) {
          this.yesterdayChart.dispose()
          this.yesterdayChart = null
        }
      }
    }
  },

  methods: {
    sortByToConsume(a, b) {
      return parseFloat(a.toConsume || 0) - parseFloat(b.toConsume || 0)
    },
    sortByYesConsume(a, b) {
      return parseFloat(a.yesConsume || 0) - parseFloat(b.yesConsume || 0)
    },
    handleFilterChange(value) {
      // 定义各组的用户列表
      const operation = ['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','詹思城','张爱'];
      const customer = ['福建追书浙江端口', '生米', '千堆雪', '福建追书福建端口'];
      const fujian =['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','福建代运营','詹思城','张爱'];
      const fujian1 = ['张栖宇', '林俊杰', '黄祥舟'];
      const fujian2 = ['周尚安', '吴周莉', '陈慧','詹思城','张爱'];
      const sales = ['郑伏金', '叶福顺', '翁媚芳','陈曦'];

      // 每次都从完整数据开始筛选
      const fullData = [...this.originalTableData];

      // 根据选择的筛选条件过滤数据
      switch (value) {
        case 'customer':
          this.tableData = fullData.filter(item => customer.includes(item.username));
          break;
        case 'operation':
          this.tableData = fullData.filter(item => operation.includes(item.username));
          break;
        case 'fujian':
          this.tableData = fullData.filter(item => fujian.includes(item.username));
          break;
        case 'fujian1':
          this.tableData = fullData.filter(item => fujian1.includes(item.username));
          break;
        case 'fujian2':
          this.tableData = fullData.filter(item => fujian2.includes(item.username));
          break;
        case 'sales':
          this.tableData = fullData.filter(item => sales.includes(item.username));
          break;
        case 'all':
        default:
          this.tableData = fullData;
          break;
      }
    },

    buildPalette(n) {
      const base = ['#2D6CDF','#67C23A','#E6A23C','#F56C6C','#8E44AD','#16A085','#3498DB','#C0392B','#1ABC9C','#F39C12','#2ECC71','#9B59B6']
      if (n <= base.length) return base.slice(0, n)
      const res = [...base]
      const golden = 0.61803398875
      let h = 0.21
      for (let i = base.length; i < n; i++) {
        h = (h + golden) % 1
        const s = 0.78
        const l = 0.56 + ((i % 3) - 1) * 0.08
        res.push(this.hslToHex(h * 360, s * 100, Math.max(38, Math.min(70, l * 100))))
      }
      return res
    },

    hslToHex(h, s, l) {
      s /= 100; l /= 100
      const c = (1 - Math.abs(2 * l - 1)) * s
      const x = c * (1 - Math.abs((h / 60) % 2 - 1))
      const m = l - c/2
      let r=0,g=0,b=0
      if (0 <= h && h < 60) { r=c; g=x; b=0 }
      else if (60 <= h && h < 120) { r=x; g=c; b=0 }
      else if (120 <= h && h < 180) { r=0; g=c; b=x }
      else if (180 <= h && h < 240) { r=0; g=x; b=c }
      else if (240 <= h && h < 300) { r=x; g=0; b=c }
      else { r=c; g=0; b=x }
      const toHex = v => ('0' + Math.round((v + m) * 255).toString(16)).slice(-2)
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`
    },

    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const t = arr[i]; arr[i] = arr[j]; arr[j] = t
      }
      return arr
    },

    //
    getRedisOverview() {
      Promise.all([
        axios.get("https://control.zjwec.cn/api/v1/fj/data/getYesOverview")
        // axios.get("http://127.0.0.1:9998/api/v1/fj/data/getYesOverview")
          .then(res => {
            const zjData = res.data.zjData || [];
            const fjData = res.data.fjData || [];
            return [...zjData, ...fjData];
          }),
        axios.get("https://control.zjwec.cn/api/v1/fj/data/getToOverview")
        // axios.get("http://127.0.0.1:9998/api/v1/fj/data/getToOverview")
          .then(res => {
            const zjData = res.data.zjData || [];
            const fjData = res.data.fjData || [];
            return [...zjData, ...fjData];
          })
      ]).then(([yesData, toData]) => {
        // 初始化表格数据
        const fullTableData = this.users.map(user => {
          // 计算昨日消费
          let yesConsume = 0;
          user.subAccountName.forEach(subAccount => {
            const account = yesData.find(item => item.subAccountName === subAccount);
            if (account && account.totalConsume) {
              yesConsume += Number(account.totalConsume);
            }
          });
          // 计算今日消费
          let toConsume = 0;
          user.subAccountName.forEach(subAccount => {
            const account = toData.find(item => item.subAccountName === subAccount);
            if (account && account.totalConsume) {
              toConsume += Number(account.totalConsume);
            }
          });
          return {
            username: user.uname,
            yesConsume: yesConsume.toFixed(2),
            toConsume: toConsume.toFixed(2)
          };
        });

        this.tableData = fullTableData;
        this.originalTableData = [...fullTableData];
        this.yesDataCache = yesData;
        this.toDataCache = toData;
        this.generateChartGroups(yesData, toData);
        if (this.selectedFilter !== 'all') {
          this.$nextTick(() => this.renderDonutCharts());
        }
      }).catch(error => {
        console.error('请求失败:', error);
      });
    },

    //
    generateChartGroups(yesData, toData) {
      // 定义各组的用户列表
      const groups = {
        '福建组': ['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','福建代运营','詹思城','张爱'],
        '福建1组': ['张栖宇', '林俊杰', '黄祥舟'],
        '福建2组': ['周尚安', '吴周莉', '陈慧','詹思城','张爱'],
        '代运营组': ['福建代运营']
      };

      // 计算各组的消费总额
      const chartGroups = [];
      for (const [groupName, userList] of Object.entries(groups)) {
        let yesterdayTotal = 0;
        let todayTotal = 0;

        // 遍历该组的所有用户
        userList.forEach(username => {
          const user = this.users.find(u => u.uname === username);
          if (user) {
            // 计算该用户的昨日消费
            user.subAccountName.forEach(subAccount => {
              const account = yesData.find(item => item.subAccountName === subAccount);
              if (account && account.totalConsume) {
                yesterdayTotal += Number(account.totalConsume);
              }
            });

            // 计算该用户的今日消费
            user.subAccountName.forEach(subAccount => {
              const account = toData.find(item => item.subAccountName === subAccount);
              if (account && account.totalConsume) {
                todayTotal += Number(account.totalConsume);
              }
            });
          }
        });

        chartGroups.push({
          name: groupName,
          yesterday: parseFloat(yesterdayTotal.toFixed(2)),
          today: parseFloat(todayTotal.toFixed(2))
        });
      }

      this.chartGroups = chartGroups;
    },

    getTrendClass(group) {
      const diff = group.today - group.yesterday;
      if (diff > 0) return 'trend-up';
      if (diff < 0) return 'trend-down';
      return 'trend-neutral';
    },

    getTrendIcon(group) {
      const diff = group.today - group.yesterday;
      if (diff > 0) return 'el-icon-arrow-up';
      if (diff < 0) return 'el-icon-arrow-down';
      return 'el-icon-minus';
    },

    getTrendText(group) {
      const diff = group.today - group.yesterday;
      const percent = group.yesterday ? ((diff / group.yesterday) * 100).toFixed(1) : 0;
      return `${diff >= 0 ? '+' : ''}${diff.toFixed(2)} (${percent}%)`;
    },

    getWowPercent(group) {
      const y = group.yesterday
      const t = group.today
      if (!y) return t > 0 ? '新增' : '0%'
      const p = ((t - y) / y) * 100
      return `${p >= 0 ? '+' : ''}${p.toFixed(1)}%`
    },

    getTrendArrow(group) {
      const diff = group.today - group.yesterday
      if (diff > 0) {
        return '<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 14 L14 2" stroke="#f56c6c" stroke-width="2" fill="none"/><path d="M10 2 L14 2 L14 6 Z" fill="#f56c6c"/></svg>'
      } else if (diff < 0) {
        return '<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 2 L14 14" stroke="#67c23a" stroke-width="2" fill="none"/><path d="M10 14 L14 14 L14 10 Z" fill="#67c23a"/></svg>'
      } else {
        return '<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 8 L14 8" stroke="#909399" stroke-width="2" fill="none"/><path d="M12 6 L14 8 L12 10 Z" fill="#909399"/></svg>'
      }
    },

    formatWan(v) {
      const n = Number(v) || 0
      if (n >= 10000) return `${(n / 10000).toFixed(2)}万`
      return n.toFixed(2)
    },

    getComparePercent(group) {
      const y = group.yesterday
      const t = group.today
      if (!y) return t > 0 ? 100 : 0
      const p = (t / y) * 100
      if (!isFinite(p)) return 0
      return Math.max(0, Math.min(100, Number(p.toFixed(1))))
    },

    getProgressStatus(group) {
      const diff = group.today - group.yesterday
      if (diff > 0) return 'success'
      if (diff < 0) return 'exception'
      return 'warning'
    },

    getGroupUsernames(filter) {
      const mapping = {
        fujian: ['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','福建代运营','詹思城','张爱'],
        fujian1: ['张栖宇', '林俊杰', '黄祥舟'],
        fujian2: ['周尚安', '吴周莉', '陈慧','詹思城','张爱'],
        customer: ['福建追书浙江端口', '生米', '千堆雪', '福建追书福建端口'],
        sales: ['郑伏金', '叶福顺', '翁媚芳','陈曦'],
        operation: ['周尚安', '张栖宇', '吴周莉', '林俊杰', '黄祥舟', '陈慧','詹思城','张爱']
      }
      return mapping[filter] || []
    },

    calcMemberConsume(username, dataset) {
      const user = this.users.find(u => u.uname === username)
      if (!user) return 0
      let total = 0
      user.subAccountName.forEach(sub => {
        const account = dataset.find(item => item.subAccountName === sub)
        if (account && account.totalConsume) total += Number(account.totalConsume)
      })
      return total
    },

    renderDonutCharts() {
      const filter = this.selectedFilter
      const members = this.getGroupUsernames(filter)
      if (!members.length) return

      const palette = this.buildPalette(members.length)
      const shuffled = this.shuffle([...palette])
      const colorMap = {}
      members.forEach((name, idx) => { colorMap[name] = shuffled[idx % shuffled.length] })

      const todaySeries = members.map(name => ({
        name,
        value: this.calcMemberConsume(name, this.toDataCache),
        itemStyle: { color: colorMap[name] }
      }))
      const yesterdaySeries = members.map(name => ({
        name,
        value: this.calcMemberConsume(name, this.yesDataCache),
        itemStyle: { color: colorMap[name] }
      }))

      const fujianBigGroup = this.getGroupUsernames('fujian')
      const fujianTodayTotal = fujianBigGroup.reduce((s, n) => s + this.calcMemberConsume(n, this.toDataCache), 0)
      const fujianYesterdayTotal = fujianBigGroup.reduce((s, n) => s + this.calcMemberConsume(n, this.yesDataCache), 0)

      const todayGroupTotal = todaySeries.reduce((s, d) => s + d.value, 0)
      const yesterdayGroupTotal = yesterdaySeries.reduce((s, d) => s + d.value, 0)

      const optionFor = title => ({
        tooltip: {
          trigger: 'item',
          confine: true,
          enterable: true,
          position: function (point, params, dom, rect, size) {
            const [x, y] = point
            const [boxW, boxH] = size.contentSize
            const [viewW, viewH] = size.viewSize

            let posX = x + 10
            if (posX + boxW > viewW) {
              posX = x - boxW - 10
            }

            let posY = y + 10
            // 预留底部图例高度，避免遮挡
            const bottomLimit = viewH - 40

            if (posY + boxH > bottomLimit) {
              posY = y - boxH - 10
            }
            if (posY < 0) posY = 0

            return [posX, posY]
          },
          formatter: params => {
            const v = params.value || 0
            const inGroup = title === '今日' ? (todayGroupTotal ? v / todayGroupTotal * 100 : 0) : (yesterdayGroupTotal ? v / yesterdayGroupTotal * 100 : 0)
            const inFujian = title === '今日' ? (fujianTodayTotal ? v / fujianTodayTotal * 100 : 0) : (fujianYesterdayTotal ? v / fujianYesterdayTotal * 100 : 0)
            return `${params.name}<br/>消费：${this.formatWan(v)}<br/>组内占比：${(inGroup||0).toFixed(2)}%<br/>福建大组占比：${(inFujian||0).toFixed(2)}%`
          }},
        legend: { type: 'scroll', bottom: 0 },
        series: [{
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: { show: false },
          labelLine: { show: false },
          data: title === '今日' ? todaySeries : yesterdaySeries
        }]
      })

      if (!this.todayChart && this.$refs.todayDonut) {
        this.todayChart = echarts.init(this.$refs.todayDonut)
      }
      if (!this.yesterdayChart && this.$refs.yesterdayDonut) {
        this.yesterdayChart = echarts.init(this.$refs.yesterdayDonut)
      }

      if (this.todayChart) {
        this.todayChart.setOption(optionFor('今日'))
        this.todayChart.resize()
        this.todayChart.off('click')
        this.todayChart.on('click', params => {
          const v = params.value || 0
          const inGroup = todayGroupTotal ? (v / todayGroupTotal * 100) : 0
          const inFujian = fujianTodayTotal ? (v / fujianTodayTotal * 100) : 0
        })
        this.todayChart.off('legendselectchanged')
        this.todayChart.on('legendselectchanged', e => {
          const name = e.name
          const idx = todaySeries.findIndex(d => d.name === name)
          if (idx > -1) {
            if (e.selected && e.selected[name] === false) {
              this.todayChart.dispatchAction({ type: 'legendSelect', name })
            }
            setTimeout(() => {
              this.todayChart.dispatchAction({ type: 'showTip', seriesIndex: 0, dataIndex: idx })
            }, 30)
          }
        })
        if (this._todayBlankClick) {
          this.todayChart.getZr().off('click', this._todayBlankClick)
        }
        this._todayBlankClick = (evt) => {
          if (!evt.target) { // 仅当点击的是 ZRender 背景时触发
            const pt = [evt.offsetX, evt.offsetY]
            const inSeries = this.todayChart && this.todayChart.containPixel({ seriesIndex: 0 }, pt)
            if (!inSeries) {
              this.todayChart.dispatchAction({ type: 'hideTip' })
              this.todayChart.dispatchAction({ type: 'downplay' })
            }
          }
        }
        this.todayChart.getZr().on('click', this._todayBlankClick)
      }

      if (this.yesterdayChart) {
        this.yesterdayChart.setOption(optionFor('昨日'))
        this.yesterdayChart.resize()
        this.yesterdayChart.off('click')
        this.yesterdayChart.on('click', params => {
          const v = params.value || 0
          const inGroup = yesterdayGroupTotal ? (v / yesterdayGroupTotal * 100) : 0
          const inFujian = fujianYesterdayTotal ? (v / fujianYesterdayTotal * 100) : 0
        })
        this.yesterdayChart.off('legendselectchanged')
        this.yesterdayChart.on('legendselectchanged', e => {
          const name = e.name
          const idx = yesterdaySeries.findIndex(d => d.name === name)
          if (idx > -1) {
            if (e.selected && e.selected[name] === false) {
              this.yesterdayChart.dispatchAction({ type: 'legendSelect', name })
            }
            setTimeout(() => {
              this.yesterdayChart.dispatchAction({ type: 'showTip', seriesIndex: 0, dataIndex: idx })
            }, 30)
          }
        })
        if (this._yesterdayBlankClick) {
          this.yesterdayChart.getZr().off('click', this._yesterdayBlankClick)
        }
        this._yesterdayBlankClick = (evt) => {
          if (!evt.target) { // 仅当点击的是 ZRender 背景时触发
            const pt = [evt.offsetX, evt.offsetY]
            const inSeries = this.yesterdayChart && this.yesterdayChart.containPixel({ seriesIndex: 0 }, pt)
            if (!inSeries) {
              this.yesterdayChart.dispatchAction({ type: 'hideTip' })
              this.yesterdayChart.dispatchAction({ type: 'downplay' })
            }
          }
        }
        this.yesterdayChart.getZr().on('click', this._yesterdayBlankClick)
      }
    },

    // 获取表格中的趋势类
    getTableTrendClass(row) {
      const today = parseFloat(row.toConsume);
      const yesterday = parseFloat(row.yesConsume);
      const diff = today - yesterday;

      if (diff > 0) return 'trend-up';
      if (diff < 0) return 'trend-down';
      return 'trend-neutral';
    },

    // 获取表格中的趋势文本
    getTableTrendText(row) {
      const today = parseFloat(row.toConsume);
      const yesterday = parseFloat(row.yesConsume);
      const diff = today - yesterday;

      if (yesterday === 0) {
        return today > 0 ? '新增' : '';
      }

      const percent = ((diff / yesterday) * 100).toFixed(1);
      return `${diff >= 0 ? '+' : ''}${diff.toFixed(2)}`;
    },

    // 判断是否应该显示趋势（避免在数据为0时显示）
    shouldShowTrend(row) {
      const today = parseFloat(row.toConsume);
      const yesterday = parseFloat(row.yesConsume);
      return !(today === 0 && yesterday === 0);
    }

  }
}
</script>

<style scoped>
.fujiandata-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.overview-card {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 16px;
}

.overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.overview-title {
  font-size: 18px;
  font-weight: 600;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.overview-item {
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.item-title {
  color: #606266;
  font-size: 14px;
  margin-bottom: 6px;
}

.item-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.today-number {
  color: #2d6cdf;
  font-size: 28px;
  font-weight: 700;
}

.subline {
  display: flex;
  gap: 8px;
  align-items: baseline;
}

.label {
  color: #909399;
}

.yesterday-number {
  color: #606266;
  font-weight: 600;
}

.trend-up {
  color: #f56c6c;
}

.trend-down {
  color: #67c23a;
}

.trend-neutral {
  color: #909399;
}

.trend-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.trend-arrow svg {
  display: inline-block;
  vertical-align: middle;
}

.donut-container {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
}

.donut-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 8px;
}

.donut-title {
  font-size: 16px;
  font-weight: 600;
  color: #606266;
}

.donut-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.donut-box {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 6px;
}

.donut-chart {
  width: 100%;
  height: 280px;
}

@media (max-width: 768px) {
  .donut-grid {
    grid-template-columns: 1fr;
  }
  .donut-chart {
    height: 220px;
  }
}
.table-container {
  margin-top: 8px;
}

.consume-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.consume-trend {
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .overview-grid {
    grid-template-columns: 1fr;
  }
  .today-number {
    font-size: 24px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/fujiandata.vue